import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "./../Styles/designdetails.css";
import { API, UPLOADS } from "../../config/api";

export default function DesigneDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const design = location.state;

  const [isAddedCart, setIsAddedCart] = useState(false);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [concepts, setConcepts] = useState([]);
  const [downloaded, setDownloaded] = useState({});
  const [showAdModal, setShowAdModal] = useState(false);
  const [adTimer, setAdTimer] = useState(30);
  const [pendingDownloadUrl, setPendingDownloadUrl] = useState(null);
  const [zoomData, setZoomData] = useState({
    show: false,
    x: 0,
    y: 0,
    xP: 0,
    yP: 0,
  });
  const handleDownloadClick = () => {
    const category = design.category.toLowerCase();

    const url = `${UPLOADS.DESIGN_FILE}${category}/emb/${design.emb_file}`;

    setPendingDownloadUrl({
      url,
      code: design.design_code,
      id: design.id,
    });

    setAdTimer(30);
    setShowAdModal(true);
  };
  useEffect(() => {
    let interval;
    if (showAdModal && adTimer > 0) {
      interval = setInterval(() => {
        setAdTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [showAdModal, adTimer]);
  // VERIFY IMAGE URL
  const imageUrl = design
    ? `${UPLOADS.DESIGN_IMAGE}${design.category.toLowerCase()}/jpg/${design.jpeg_file}`
    : "";

  useEffect(() => {
    fetchConcepts();
    syncStatus();
    window.addEventListener("cartUpdated", syncStatus);
    window.addEventListener("storage", syncStatus);
    return () => {
      window.removeEventListener("cartUpdated", syncStatus);
      window.removeEventListener("storage", syncStatus);
    };
  }, [design]);

  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();
      if (data.status) setConcepts(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const syncStatus = () => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loginUser || !design) return;
    const wishlist =
      JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
    const cart = JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
    setIsWishlisted(
      wishlist.some((item) => item.id === design.id && item.type === "design"),
    );
    setIsAddedCart(
      cart.some((item) => item.id === design.id && item.type === "design"),
    );
  };

  const handleMouseMove = (e) => {
    const container = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - container.left;
    const y = e.clientY - container.top;

    // Map mouse position to percentages
    const xPercent = (x / container.width) * 100;
    const yPercent = (y / container.height) * 100;

    setZoomData({ show: true, x, y, xP: xPercent, yP: yPercent });
  };

  const toggleCart = () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return alert("Please Login First");

    let items = JSON.parse(localStorage.getItem(`cart_${user.id}`)) || [];

    const exists = items.find((i) => i.id === design.id && i.type === "design");

    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setIsAddedCart(false);
    } else {
      items.push({ ...design, type: "design" });
      setIsAddedCart(true);
    }

    localStorage.setItem(`cart_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const toggleWishlist = () => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return alert("Please Login First");

    let items = JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];

    const exists = items.find((i) => i.id === design.id && i.type === "design");

    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setIsWishlisted(false);
    } else {
      items.push({ ...design, type: "design" });
      setIsWishlisted(true);
    }

    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  if (!design) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div className="container-fluid design-details-container py-5">
      <div className="container">
        <button
          className="btn btn-outline-secondary mb-4"
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left"></i> Back to Designs
        </button>

        <div className="row g-4">
          {/* LEFT COLUMN */}
          <div className="col-lg-5">
            <div
              className="details-image-wrapper shadow-sm rounded"
              onMouseMove={handleMouseMove}
              onMouseEnter={() => setZoomData((p) => ({ ...p, show: true }))}
              onMouseLeave={() => setZoomData((p) => ({ ...p, show: false }))}
            >
              <img
                src={imageUrl}
                alt={design.design_code}
                className="main-design-img"
              />
              {zoomData.show && (
                <div
                  className="zoom-viewfinder"
                  style={{
                    left: `${zoomData.x - 75}px`,
                    top: `${zoomData.y - 75}px`,
                  }}
                />
              )}
            </div>
          </div>

          {/* RIGHT COLUMN: Hides content and shows image when hovering */}
          <div className="col-lg-7">
            {zoomData.show ? (
              <div
                className="zoom-result-window"
                style={{
                  backgroundImage: `url("${imageUrl}")`,
                  backgroundSize: "150%", // Increased for better detail
                  backgroundPosition: `${zoomData.xP}% ${zoomData.yP}%`,
                }}
              />
            ) : (
              <div className="details-content">
                <span className="badge bg-light mb-2 p-3">
                  {design.category}
                </span>
                <h1 className="h2 fw-bold text-dark mb-3">
                  Design Code: {design.design_code}
                </h1>
                <h3 className="text-success fw-bold mb-4">₹ FREE</h3>

                <div className="specs-grid p-4 mb-4 bg-light rounded border">
                  <div className="spec-row mb-2">
                    <strong>Stitches :</strong> {design.stitch}
                  </div>
                  <div className="spec-row mb-2">
                    <strong>Area :</strong> {design.area}
                  </div>
                  <div className="spec-row mb-2">
                    <strong>Colours :</strong> {design.color}
                  </div>
                  <div className="spec-row mb-2">
                    <strong>Format :</strong> .EMB
                  </div>
                  <div className="spec-row">
                    <strong>Concept :</strong>{" "}
                    {design.concepts_array
                      ?.map(
                        (id) => concepts.find((c) => c.id == id)?.concept_name,
                      )
                      .filter(Boolean)
                      .join(", ")}
                  </div>
                  <div className="spec-row mb-2">
                    <strong>Details :</strong> {design.details}
                  </div>
                </div>
                {downloaded[design.id] ? (
                  <button className="btn btn-teal1 btn-sm">
                    <i className="bi bi-check-circle-fill me-1"></i>
                    Downloaded
                  </button>
                ) : (
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownloadClick();
                    }}
                    className="btn btn-teal btn-sm"
                  >
                    <i className="bi bi-download me-1"></i>
                    Download
                  </button>
                )}
              </div>
            )}
            {/* <div className="action-buttons d-flex gap-3">
                  <button
                    className={`btn flex-fill p-3 ${isAddedCart ? "btn-add" : "btn-cart"}`}
                    onClick={toggleCart}
                  >
                    <i
                      className={`bi ${isAddedCart ? "bi-cart-check-fill" : "bi-cart-fill"} me-1`}
                    ></i>
                    {isAddedCart ? "ADDED TO CART" : "SELECT DESIGN"}
                  </button>
                  <button
                    className="btn btn-wishlist flex-fill p-3"
                    onClick={toggleWishlist}
                  >
                    <i
                      className={`bi ${isWishlisted ? "bi-heart-fill" : "bi-heart"} me-2`}
                    ></i>
                    {isWishlisted ? "WISHLISTED" : "WISHLIST"}
                  </button>
                </div> */}
          </div>
        </div>
      </div>
      {showAdModal && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-dialog">
            <div className="custom-modal-content">
              <div className="modal-header-custom">
                <h2 className="modal-title">Unlocking Your Design</h2>
                <p>We provide 100% free designs thanks to our sponsors.</p>
              </div>

              <div className="ad-card">
                <div className="ad-badge">SPONSORED AD</div>
                <div className="ad-body">
                  {/* <h4 className="ad-brand">Premium Embroidery Supplies</h4>
            <p className="ad-offer">Upgrade your toolkit with 20% off all thread kits.</p> */}
                  <h4 className="ad-brand">Your Ads Here</h4>

                  <div className="ad-visual-placeholder">
                    {/* You can place an actual <img> here */}
                    <div className="pulse-loader"></div>
                  </div>
                </div>
              </div>

              <div className="action-section">
                {adTimer > 0 ? (
                  <div className="timer-wrapper">
                    <span className="timer-text">Preparing your file...</span>
                    <div className="timer-number">{adTimer}s</div>
                  </div>
                ) : (
                  <div className="download-ready-area">
                    <p className="ready-msg"> Your file is ready!</p>
                    <a
                      href={pendingDownloadUrl?.url}
                      className="btn-download-glow"
                      onClick={(e) => {
                        e.preventDefault();

                        const url = pendingDownloadUrl?.url;
                        const code = pendingDownloadUrl?.code;
                        const id = pendingDownloadUrl?.id;

                        if (!url) return;

                        // ✅ detect extension properly
                        let ext = "emb";
                        if (url.includes(".zip")) ext = "zip";
                        else if (url.includes(".rar")) ext = "rar";

                        // ✅ create ONE download link only
                        const link = document.createElement("a");
                        link.href = url;
                        link.download = `${code}.${ext}`;

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        // ✅ mark as downloaded
                        setDownloaded((prev) => ({
                          ...prev,
                          [id]: true,
                        }));

                        // ✅ close modal
                        setShowAdModal(false);
                      }}
                    >
                      Download Now
                    </a>
                  </div>
                )}
              </div>

              <button
                className="btn-close-modal"
                onClick={() => setShowAdModal(false)}
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      )}
      <style>{`
        .btn-teal { background-color: #00a99d; color: white; border: none; padding: 10px; width:100%;}
        
.btn-teal1 { background-color: #146862; color: white; border: none; padding: 10px; width:100%;}
        .design-img-box { overflow: hidden; position: relative; background: #f8f9fa; }
        
        /* BILLARY MIRROR (Zoom Lens) CSS */
    

        .object-fit-contain { object-fit: contain; }



/* Modal Box */
.custom-modal-content {
  background: #ffffff;
  width: 90%;
  max-width: 450px;
  border-radius: 24px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
  position: relative;
  margin-left:16px;
}

.modal-title {
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 1.5rem;
}

/* Ad Container Styling */
.ad-card {
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  padding: 20px;
  margin: 25px 0;
  position: relative;
}

.ad-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #10334b;
  color: white;
  font-size: 10px;
  font-weight: bold;
  padding: 4px 12px;
  border-radius: 20px;
  letter-spacing: 1px;
}

.ad-brand {
  color: #132e4d;
  font-weight: 700;
  margin-top: 10px;
}

/* Timer Styling */
.timer-number {
  font-size: 2.5rem;
  font-weight: 800;
  color: #ef4444;
  margin-top: 10px;
}

/* Pulsing Loader Animation */
.pulse-loader {
  width: 40px;
  height: 40px;
  border: 4px solid #e2e8f0;
  border-top: 4px solid #2e4563;
  border-radius: 50%;
  margin: 15px auto;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Glow Download Button */
.btn-download-glow {
  display: inline-block;
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  color: white;
  text-decoration: none;
  padding: 15px 30px;
  border-radius: 12px;
  font-weight: bold;
  font-size: 1.1rem;
  width: 100%;
  box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.4);
  transition: transform 0.2s ease;
}

.btn-download-glow:hover {
  transform: translateY(-2px);
  color: white;
}

.btn-close-modal {
  background: none;
  border: none;
  color: #94a3b8;
  margin-top: 20px;
  cursor: pointer;
  font-size: 0.9rem;
  text-decoration: underline;
}
      `}</style>
    </div>
  );
}
